import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const OportunidadSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        Propuesta de Valor Agregado
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        El &quot;Efecto Multiplicador&quot; para sus Aliados
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Transformamos un patrocinio de 3 días en una campaña estratégica de 3 meses.
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        La alianza con TNO Network le otorga a los organizadores de Actitud Plateada 2026 un argumento de venta imbatible para sus patrocinadores actuales y potenciales. No ofrecemos solo una valla en el torneo; ofrecemos presencia sostenida en el ecosistema digital más influyente:
      </Typography>

      <Box sx={{ '& > div': { mb: 2 } }}>
        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Visibilidad de Larga Duración (Pre-Evento)
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Desde este momento y durante los próximos 3 meses, las marcas aliadas recibirán exposición continua. El torneo se convierte en el clímax de una campaña de posicionamiento que comienza hoy mismo.
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Omnicanalidad Real
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            El contenido de las marcas rotará a través de toda nuestra arquitectura:
          </Typography>
          <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 0 }}>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Señal TNO:</strong> Presencia en nuestra rotativa audiovisual.
            </Typography>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>TNO Digest:</strong> Artículos y crónicas donde los patrocinadores son protagonistas de la narrativa del bienestar y el deporte.
            </Typography>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Redes Sociales:</strong> Difusión estratégica para amplificar el alcance.
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Cobertura Premium (Durante y Post)
          </Typography>
          <Typography variant="body2" color="textSecondary">
            El despliegue en campo asegura que la inversión de las marcas sea documentada con calidad televisiva, generando material de alto valor para su propio marketing.
          </Typography>
        </Box>
      </Box>

      <Typography variant="subtitle2" color="primary" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        El Beneficio para el Organizador
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Este ecosistema garantiza que sus patrocinadores perciban un retorno de inversión (ROI) muy superior, ganando autoridad y visibilidad continua antes, durante y después del evento.
      </Typography>
    </Box>
  );
};

export default OportunidadSection;
